var map = {
	"./main/apps/apps.module": [
		"./src/app/main/apps/apps.module.ts",
		"main-apps-apps-module"
	],
	"./main/pages/pages.module": [
		"./src/app/main/pages/pages.module.ts",
		"common",
		"main-pages-pages-module"
	],
	"./main/ui/ui.module": [
		"./src/app/main/ui/ui.module.ts",
		"main-ui-ui-module"
	],
	"./scrumboard/scrumboard.module": [
		"./src/app/main/apps/scrumboard/scrumboard.module.ts",
		"common",
		"scrumboard-scrumboard-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;